export default {
      name_ar: 'name_ar',
    name_en: 'name_en',

};
